// 明細列拖曳排序時,「放開之後要搬到哪裡」。
//
// 業主 2026-09-23:「明細列的上移下移 可以用拖曳的嗎」。
//
// ==========================================================================
// 為什麼這件事單獨一支
// ==========================================================================
// jsdom 沒有版面、沒有指標座標,dnd-kit 在測試裡量不到任何一列的位置,
// 真的拖曳演不出來。把判斷抽出來之後,邊界條件(拖到空處、原地放開、
// 拖到別章節去)就測得乾淨,而 `LineTable` 那邊只剩三行接線。
//
// **它不認得 dnd-kit**,只認得一串 uid。哪天換掉拖曳套件,這一支不必改。

export interface LineMove {
  from: number;
  to: number;
}

/**
 * 從 dnd-kit 的 `onDragEnd` 算出要搬的位置。**什麼都不該做時回 `null`。**
 *
 * @param uids   這個章節的每一列,依畫面順序。
 * @param active 被拖的那一列。
 * @param over   放開時指標停在哪一列;沒停在任何一列上是 `null`。
 */
export function dropTarget(
  uids: string[],
  active: string | number | null | undefined,
  over: string | number | null | undefined,
): LineMove | null {
  // 拖到表格外放開。這裡要是回 `{ to: 0 }`,手滑就會把那一列扔到最上面。
  if (over === null || over === undefined) return null;
  // 原地放開。回 `{ from: 2, to: 2 }` 的話草稿會被標成「有未存檔的改動」,
  // 而畫面上一個字都沒變 —— 使用者會以為自己不小心動到了什麼。
  if (active === over) return null;

  const from = uids.indexOf(String(active));
  const to = uids.indexOf(String(over));
  // SortableContext 只收這一章的 uid,但 onDragEnd 仍可能收到別處的 id。
  if (from < 0 || to < 0) return null;

  return { from, to };
}
